import {IResponseEntity} from '@toolify/server/src/services/EntityService/types/IResponseEntity'
import {EntityType} from '@toolify/server/src/services/EntityService/enum/EntityType'

export function getViaEntityLabelKey(viaEntity: Pick<IResponseEntity, 'entityType'> | null | undefined): string {
  return viaEntity?.entityType === EntityType.Agent ? 'settings.activityViaAgent' : 'settings.activityViaEntity'
}
